<script setup lang="ts">
// Vendor
import type {
  Block,
  Inline,
  Text,
  Hyperlink,
  EntryHyperlink,
} from "@contentful/rich-text-types";

const { nodes } = defineProps<{
  /**
   * The content to render.
   */
  nodes?: (Block | Inline | Text | Hyperlink | EntryHyperlink)[];
}>();

const localePath = useLocalePath();

/**
 * Map that converts Contentful mark to a valid HTML tag.
 */
const MARKS_MAP: Record<string, string> = {
  bold: "b",
  italic: "i",
  underline: "u",
};
</script>

<template>
  <template v-if="nodes">
    <template v-for="(node, key) in nodes" :key="key">
      <template v-if="node.nodeType === 'text' && node.value">
        <template v-if="node.marks.length">
          <component
            v-for="(mark, key) in node.marks"
            :key="key"
            :is="MARKS_MAP[mark.type]"
          >
            {{ node.value }}
          </component>
        </template>
        <template v-else>
          {{ node.value }}
        </template>
      </template>
      <p v-if="node.nodeType === 'paragraph' && node.content.length">
        <ContentfulNodeRenderer :nodes="node.content" />
      </p>

      <FoundationList
        v-if="
          (node.nodeType === 'unordered-list' ||
            node.nodeType === 'ordered-list') &&
          node.content.length
        "
      >
        <ContentfulNodeRenderer :nodes="node.content" />
      </FoundationList>

      <FoundationListItem
        v-if="node.nodeType === 'list-item' && node.content.length"
      >
        <template #start>
          <Icon name="citizenm:checkmark" />
        </template>
        <ContentfulNodeRenderer :nodes="node.content" />
      </FoundationListItem>

      <NuxtLink v-if="node.nodeType === 'hyperlink'" :to="node.data.uri">
        <ContentfulNodeRenderer :nodes="node.content" />
      </NuxtLink>

      <NuxtLink
        v-if="node.nodeType === 'entry-hyperlink'"
        :to="localePath(`/${stripLeadingSlash(node.data.target.fields.slug)}`)"
      >
        <ContentfulNodeRenderer :nodes="node.content" />
      </NuxtLink>
    </template>
  </template>
</template>
